/**
 * WaveDictionaryEntry — shared component used by both /overview and /investor.
 *
 * Premium dictionary-style definition card. Italic "wave" headword,
 * phonetic spelling, part-of-speech, year tag, and the precise
 * patent-claim language definition. Off-white card background (#1F1F1F)
 * with a thin teal left border to mimic a printed dictionary page.
 */
import React from 'react';

const TEAL = '#00D4FF';
const PINK = '#FF4D94';

export default function WaveDictionaryEntry({ kicker = 'What is a Wave?', testid = 'wave-dictionary-entry' }) {
  return (
    <section className="relative" data-testid={testid}>
      <p className="text-[11px] uppercase tracking-[0.28em] font-black mb-3" style={{ color: PINK }}>
        {kicker}
      </p>
      <article
        className="relative rounded-xl py-8 px-7 lg:px-10 transition-all duration-500"
        style={{
          background: '#1F1F1F',
          borderLeft: `3px solid ${TEAL}`,
          boxShadow: `0 0 38px rgba(0,212,255,0.10), inset 0 0 0 1px rgba(255,255,255,0.02)`,
        }}
        data-testid={`${testid}-card`}
      >
        {/* Headword + grammar line */}
        <div className="flex items-baseline gap-3 lg:gap-4 flex-wrap mb-5">
          <h2
            className="text-5xl lg:text-6xl font-black tracking-tight text-white leading-none italic"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
            data-testid={`${testid}-headword`}
          >
            wave
          </h2>
          <span className="text-base text-gray-500 italic" style={{ fontFamily: "Georgia, serif" }}>verb</span>
          <span className="text-base text-gray-400 font-mono">/wāv/</span>
          <span className="text-[10px] uppercase tracking-[0.22em] font-black px-2.5 py-1 rounded-full"
                style={{ color: TEAL, border: `1px solid ${TEAL}55`, background: `${TEAL}11` }}>
            2027
          </span>
          <span className="text-[11px] italic text-gray-500" style={{ fontFamily: "Georgia, serif" }}>
            Advertising &amp; Media
          </span>
        </div>

        {/* Definition */}
        <p
          className="text-[15px] lg:text-base text-gray-200 leading-[1.7] max-w-3xl"
          style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
        >
          <span className="text-gray-500 mr-1">1.</span>
          To deploy a cohort of micro-creators, each trusted by a small but high-value following, in one coordinated window so that their disparate networks compound: many small, trusted audiences reached at once, through voices they already listen to. Each creator posts natively with their own angle; the brand rents the attention of many micro-communities with one purchase.
        </p>

        <p className="text-[9px] uppercase tracking-[0.25em] text-gray-600 font-bold mt-6">
          Definition &middot; WAVE
        </p>
      </article>
    </section>
  );
}
